import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { CollectionPreviewTooltipFragment } from "@/components/collection/CollectionPreviewTooltip/CollectionPreviewTooltip.fragment"
import { collectionUrlFragment } from "@/components/collection/utils"
import { CollectionCurrencyPreviewSheetFragment } from "./CollectionCurrencyPreviewSheet.fragment"

export const CollectionCurrencyPreviewFragment = graphql(
  `
    fragment CollectionCurrencyPreview on Currency {
      ...CollectionCurrencyPreviewSheet
      collections {
        slug
        ...collectionUrl
        ...CollectionLockup
        ...CollectionPreviewTooltip
      }
    }
  `,
  [
    collectionUrlFragment,
    CollectionLockupFragment,
    CollectionPreviewTooltipFragment,
    CollectionCurrencyPreviewSheetFragment,
  ],
)
